var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi8621814(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 7C22.75 6.536 22.566 6.091 22.237 5.763C21.909 5.434 21.464 5.25 21 5.25C17.586 5.25 6.414 5.25 3 5.25C2.536 5.25 2.091 5.434 1.763 5.763C1.434 6.091 1.25 6.536 1.25 7V17C1.25 17.464 1.434 17.909 1.763 18.237C2.091 18.566 2.536 18.75 3 18.75H21C21.464 18.75 21.909 18.566 22.237 18.237C22.566 17.909 22.75 17.464 22.75 17V7ZM12.75 9.25V9C12.75 8.586 12.414 8.25 12 8.25C11.586 8.25 11.25 8.586 11.25 9V9.418C10.659 9.699 10.25 10.302 10.25 11C10.25 11.966 11.034 12.75 12 12.75C12.138 12.75 12.25 12.862 12.25 13C12.25 13.138 12.138 13.25 12 13.25H11C10.586 13.25 10.25 13.586 10.25 14C10.25 14.414 10.586 14.75 11 14.75H11.25V15C11.25 15.414 11.586 15.75 12 15.75C12.414 15.75 12.75 15.414 12.75 15V14.582C13.341 14.301 13.75 13.698 13.75 13C13.75 12.034 12.966 11.25 12 11.25C11.862 11.25 11.75 11.138 11.75 11C11.75 10.862 11.862 10.75 12 10.75H13C13.414 10.75 13.75 10.414 13.75 10C13.75 9.586 13.414 9.25 13 9.25H12.75ZM16.5 12.75H18.5C18.914 12.75 19.25 12.414 19.25 12C19.25 11.586 18.914 11.25 18.5 11.25H16.5C16.086 11.25 15.75 11.586 15.75 12C15.75 12.414 16.086 12.75 16.5 12.75ZM5.5 12.75H7.5C7.914 12.75 8.25 12.414 8.25 12C8.25 11.586 7.914 11.25 7.5 11.25H5.5C5.086 11.25 4.75 11.586 4.75 12C4.75 12.414 5.086 12.75 5.5 12.75Z",
    fill: "#5158E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94629 19.75L4.85629 21.462C5.30929 22.315 6.36929 22.639 7.22229 22.185L11.8023 19.75H3.94629ZM12.1983 4.24998H20.0543L19.1443 2.53798C18.6913 1.68498 17.6313 1.36098 16.7783 1.81498L12.1983 4.24998Z",
    fill: "#5158E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi8621814);
export default __webpack_public_path__ + "static/media/fi_8621814.5071aa4435d9500fbc699fed5c255259.svg";
export { ForwardRef as ReactComponent };